import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'punishment'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const punishmentCreate = 'Master/Punishment/create/'
export const punishmentList = 'Master/Punishment/list/'
export const punishmentListParent = 'Master/Punishment/parent/'
export const punishmentListType = 'Master/Punishment/type/'
export const punishmentListSignatory = 'Master/Punishment/signatory/'
export const punishmentDetail = 'Master/Punishment/detail/'
export const punishmentUpdate = 'Master/Punishment/update/'
export const punishmentInactive = 'Master/Punishment/inactive/'
export const punishmentActive = 'Master/Punishment/active/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}